import { getEntityWithoutTypename } from "pages/utils";

export const handleSubmit = ({ updateUser, history, currentCustomerId, username, contracts }) => values => {
  const userCustomerContracts = contracts
    ?.filter(contract => values.customerIds.includes(contract.customer_id))
    ?.map(c => c._id);

  if (userCustomerContracts.length < values.serviceContractsFilter.length) {
    values.serviceContractsFilter = userCustomerContracts;
  } else if (userCustomerContracts.length === values.serviceContractsFilter.length) {
    values.serviceContractsFilter = [];
  }

  const updatedData = updateUser({
    variables: {
      userInput: {
        ...getEntityWithoutTypename(values),
        confirmPassword: undefined,
      },
      customerId: currentCustomerId,
      username,
    },
  });

  return updatedData.then(result => {
    const user = result.data.updateUser;
    if (user) {
      history.goBack();
    }
  });
};
